// 团队任务管理 API
import { createAppRequest } from '@/services/request';

const request = createAppRequest();

import type { Task, TaskPriority, TaskStatus } from './type';

// ==================== 团队任务管理 API ====================

// 团队任务相关接口
export const teamTaskApi = {
  // 获取团队任务列表
  getTeamTasks: (params?: {
    page?: number;
    limit?: number;
    status?: TaskStatus[];
    priority?: TaskPriority[];
    teamId?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) {
      searchParams.append('page', params.page.toString());
    }
    if (params?.limit) {
      searchParams.append('limit', params.limit.toString());
    }
    if (params?.status) {
      params.status.forEach((s) => {
        searchParams.append('status', s);
      });
    }
    if (params?.priority) {
      params.priority.forEach((p) => {
        searchParams.append('priority', p);
      });
    }
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }

    return request<{ tasks: Task[]; total: number }>(
      `/bff/tasks/team-tasks?${searchParams.toString()}`,
      {
        method: 'GET',
      },
    );
  },

  // 获取团队成员任务统计
  getTeamTaskStats: (params?: {
    teamId?: string;
    startDate?: string;
    endDate?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }

    return request<{
      totalTasks: number;
      completedTasks: number;
      inProgressTasks: number;
      overdueTasks: number;
      memberStats: Array<{
        memberId: string;
        memberName: string;
        totalTasks: number;
        completedTasks: number;
        inProgressTasks: number;
        overdueTasks: number;
      }>;
    }>(`/bff/tasks/team-task-stats?${searchParams.toString()}`, {
      method: 'GET',
    });
  },

  // 批量分配任务
  batchAssignTasks: (data: {
    taskIds: string[];
    assigneeUuid: string;
    dueDate?: string;
    priority?: TaskPriority;
  }) =>
    request<{ success: number; failed: number }>('/bff/tasks/batch-assign', {
      method: 'POST',
      data,
    }),

  // 获取团队工作量
  getTeamWorkload: (params?: {
    teamId?: string;
    startDate?: string;
    endDate?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }

    return request<{
      totalWorkload: number;
      averageWorkload: number;
      memberWorkloads: Array<{
        memberId: string;
        memberName: string;
        workload: number;
        taskCount: number;
      }>;
    }>(`/bff/tasks/team-workload?${searchParams.toString()}`, {
      method: 'GET',
    });
  },
};
